import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';

const messages = [
  {
    sender: 'customer',
    text: 'My water heater just exploded. There is water everywhere. Can someone come out tonight?',
    time: '8:47 PM'
  },
  {
    sender: 'ai',
    text: 'I am so sorry to hear that! We can definitely help. We have an emergency technician available in 45 minutes. Our emergency dispatch fee is $149 — should I send them over?',
    time: '8:47 PM'
  },
  {
    sender: 'customer',
    text: 'Yes, please! My name is John at 123 Maple St.',
    time: '8:48 PM'
  },
  {
    sender: 'ai',
    text: 'Got it, John. Technician Mike is on his way. I have sent a calendar invite to your phone. See you soon!',
    time: '8:48 PM'
  }
];

export const SMSSimulation = () => {
  return (
    <section className="py-24 sm:py-32 bg-[#0F0F13]">
      <div className="max-w-5xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl sm:text-5xl font-headline font-bold text-[#F4F4F5] mb-4">
            See it in action:{' '}
            <span className="gradient-text">A Friday Night Emergency Call</span>
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="max-w-md mx-auto"
        >
          {/* iPhone Mockup */}
          <div className="relative">
            <div className="glass rounded-3xl p-4 border-4 border-white/10">
              {/* Phone Header */}
              <div className="bg-[#050505] rounded-t-2xl px-4 py-3 flex items-center gap-3 mb-4">
                <MessageCircle className="w-6 h-6 text-[#00E599]" />
                <div>
                  <p className="text-sm font-body font-semibold text-[#F4F4F5]">AI Office Manager</p>
                  <p className="text-xs text-[#A1A1AA]">Online</p>
                </div>
              </div>

              {/* Messages */}
              <div className="space-y-4 bg-[#000000] rounded-2xl p-4 min-h-[400px]">
                {messages.map((message, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4, delay: index * 0.2 }}
                    className={`flex ${message.sender === 'customer' ? 'justify-start' : 'justify-end'}`}
                  >
                    <div className={`max-w-[80%] ${message.sender === 'customer' ? 'order-1' : 'order-2'}`}>
                      <div
                        className={`rounded-2xl px-4 py-3 ${
                          message.sender === 'customer'
                            ? 'bg-[#1C1C1E] text-[#F4F4F5]'
                            : 'bg-[#00E599] text-[#050505]'
                        }`}
                      >
                        <p className="text-sm font-body leading-relaxed">{message.text}</p>
                      </div>
                      <p className="text-xs text-[#666666] mt-1 px-2">{message.time}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>

          {/* Caption */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.8 }}
            className="text-center mt-8 glass p-6 rounded-xl"
          >
            <p className="text-xl font-headline font-bold gradient-text">
              That is a $3,000 install booked while you were at dinner with your family.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default SMSSimulation;
